
export default {
  // Common
  "language": "语言",
  "language_description": "更改整个应用程序中使用的语言",
  "save_language": "保存语言偏好",
  "updating": "更新中...",
  "return_home": "返回首页",
  "sign_out": "退出登录",
  "error": "错误",
  "loading": "加载中...",
  "cancel": "取消",
  "save": "保存",
  "edit": "编集",
  "delete": "删除",
  "back": "返回",
  "view_details": "查看详情",
  "not_applicable": "N/A",
  "invalid_date": "无效日期",
  "name": "名称",
  "qty": "数量",
  "actions": "操作",
  "sort_by": "排序方式",
  "filter_by": "筛选方式",
  "ascending": "升序",
  "descending": "降序",
  "date_added": "添加日期",
  "retry": "重试",
  "with": "使用",
  "or": "或",
  "format": "格式",
  "username": "用户名",
  "phone_number": "电话号码",
  "email": "电子邮件",
  "change": "更改",
  "save_changes": "保存更改",
};
